module.exports = __webpack_public_path__ + "img/BlickAufsMeer.a53ff0df.jpg";